<script>
export default {
  name: 'SelectBox',
  props: {
    disabled: { type: Boolean, required: false },
    placeholder: { type: String, required: false },
    // [{ value, label, disabled? }]
    options: {
      type: Array,
      required: true,
      validator(value) {
        if (!Array.isArray(value)) return false
        return value.every(el => typeof el === 'object' && el && 'value' in el && 'label' in el)
      },
    },
    // ※ value 指定（label ではない）
    defaultValue: { type: String, required: false, default: '' },
    size: { type: String, default: 'default' },
    width: { type: Number, default: 240 },
    popperClassName: { type: String, default: '' },
    customClass: { type: String, default: '' },
  },

  data() {
    return { value: this.defaultValue }
  },

  watch: {
    defaultValue(newVal) { this.value = newVal },
  },

  computed: {
    selectStyle() { return { width: `${this.width}px` } },
    popperClass() { return `dc-select-popper ${this.popperClassName || ''}`.trim() },
    selectedOption() {
      return this.options.find(op => op.value === this.value) || null
    },
    hasValue() {
      return !!(this.selectedOption && this.isImgDataURL(this.selectedOption.label))
    },
  },

  methods: {
    handleSelect(val) { this.$emit('update', val) },
    isImgDataURL(str) { return typeof str === 'string' && str.indexOf('data:image') === 0 },
  },
}
</script>

<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    :placeholder="placeholder"
    :size="size"
    :style="selectStyle"
    :popper-class="popperClass"
    :class="['icon-select', customClass, { 'has-value': hasValue }]"
    @change="handleSelect"
  >
    <!-- 選択値が画像ラベルの時のみ prefix を表示 -->
    <template v-if="hasValue" slot="prefix">
      <slot name="label" :selected="selectedOption">
        <img
          :src="selectedOption.label"
          alt=""
          class="icon-select__current"
        />
      </slot>
    </template>

    <!-- ドロップダウンの各項目（親が option スロットで画像を描ける） -->
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :disabled="item.disabled"
    >
      <slot v-if="$scopedSlots.option" name="option" :item="item" />
      <template v-else>{{ item.label }}</template>
    </el-option>
  </el-select>
</template>

<style>
.el-select__popper.dc-select-popper { --el-color-primary: #5171cb; }
</style>

<style scoped>
.el-select {
  --el-text-color-placeholder: #606266;
  --el-fill-color-blank: #fafafa;
  --el-border-radius-base: 0;
}

/* ★ value がある時だけ文字を消してアイコン表示に寄せる */
.icon-select.has-value >>> .el-input__inner {
  color: transparent;      /* ラベル文字（dataURL等）を不可視に */
  text-shadow: none;
  /* prefix を置く余白。prefix自体が確保することが多いが保険で */
  padding-left: 32px;
}
.icon-select >>> .el-input__prefix {
  left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-select__current {
  width: 18px;   /* お好みで 20 に */
  height: 18px;
  display: block;
}
</style>
